import WrapperTarifasCard from './WrapperTarifasCard'

export default WrapperTarifasCard
